import { render, staticRenderFns } from "./SpinePlayer.vue?vue&type=template&id=1c3d55c0&lang=pug"
import script from "./SpinePlayer.vue?vue&type=script&lang=js"
export * from "./SpinePlayer.vue?vue&type=script&lang=js"
import style0 from "./SpinePlayer.vue?vue&type=style&index=0&id=1c3d55c0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports